import script from "./BusinessHallBJ1.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessHallBJ1.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessHallBJ1.vue?vue&type=style&index=0&id=585cbec7&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585cbec7"]])

export default __exports__